import React from 'react';
import cn from 'classnames';

import { Icon } from 'components/shared/Icon';

import styles from './ToolbarIcon.module.scss';

const ToolbarIcon = ({
  className,
  active,
  iconName,
  onClick,
}: {
  className: any;
  active: any;
  iconName: any;
  onClick: any;
}) => (
  <>
    <Icon
      className={cn(styles.icon, { [styles.iconActive]: active }, className)}
      name={iconName}
      onMouseDown={onClick}
    />
  </>
);

export default React.memo(ToolbarIcon) as any;
